// Incorporation Entity (Demo) Routes
// auto-loaded via import.meta.glob in router/index.ts
import type { RouteRecordRaw } from 'vue-router';

export const incorporationEntityRoutes: RouteRecordRaw[] = [
  {
    path: '/incorporation-entity',
    name: 'IncorporationEntity',
    component: () => import('./views/IncorporationEntityPage.vue'),
    meta: {
      title: 'Incorporation (Demo)',
      requiresAuth: true,
      layout: 'default',
    },
  },
  {
    path: '/incorporation-entity/detail/:icpCd',
    name: 'IncorporationEntityDetail',
    component: () => import('./views/IncorporationEntityDetailPage.vue'),
    meta: {
      title: 'Incorporation (Demo) - Detail',
      requiresAuth: true,
      layout: 'default',
    },
  },
];

export default incorporationEntityRoutes;
